import React from "react";
import PropTypes from "prop-types";

import TableHeader from "../../../component/tableHeader/TableHeader";
import useSortableData from "../../../customHooks/sortingHooks";
import { tableHeaderData } from "./staticShiftData";
import { Link } from "react-router-dom";
import {
  advancedFilterWorker,
  sortShiftDateAscendingOrder,
  tableSkeleton
} from "../../../constant/helper/helper";
import DateList from "./DateList";

const ShiftList = ({
  shiftListData,
  dateArrayState,
  values,
  loading,
  dateDifference
}) => {
  const { items, requestSort, sortConfig } = useSortableData(
    shiftListData
  );

  const onHeaderChange = (valueObject) => {
    return dateArrayState.map((dateRange, dateRangeIndex) => (
      <th key={dateRangeIndex} className="text-center">
        {dateRange}
      </th>
    ));
  };

  const showUserList = (sheetData) => {
    if (loading) {
      return <tr>{tableSkeleton(4 + Number(dateDifference))}</tr>;
    } else if (
      typeof sheetData !== "undefined" &&
      sheetData !== null &&
      sheetData.length > 0
    ) {
      const filterEmployees = advancedFilterWorker(
        sheetData,
        values.Filter,
        "fullNameAndId"
      );
      return filterEmployees.map((mapData, parentIndex) => {
        const sortedDateList = sortShiftDateAscendingOrder(mapData);

        return (
          <tr key={parentIndex} style={{ fontSize: 12 }}>
            <td>{parentIndex + 1}</td>
            <td style={{ fontSize: 12 }}>{mapData.workerId}</td>
            <td className="table-user">
              <span className="text-body font-weight-semibold">
                <Link to={`/hr/user/all-users/${mapData.employeeId}`}>
                  {mapData.workerFullName}
                </Link>
              </span>
            </td>
            <DateList dayList={sortedDateList} />
          </tr>
        );
      });
    } else if (sheetData === null) {
      return (
        <tr style={{ top: "50%", left: "50%", position: "fixed" }}>
          <td>
            <span className="">
              Please Select From Date, To Date and Location
            </span>
          </td>
        </tr>
      );
    } else if (sheetData.length === 0) {
      return (
        <tr style={{ top: "50%", left: "50%", position: "fixed" }}>
          <td>
            <span className=""> No Record Found</span>
          </td>
        </tr>
      );
    }
  };

  return (
    <div
      className="table-responsive"
      style={{ height: "700px", overflow: "auto" }}
    >
      <table
        className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
        id="products-datatable"
      >
        <thead className="thead-light">
          <tr>
            <th style={{ width: "20px" }}>#</th>
            <TableHeader
              tableHeaderData={tableHeaderData}
              requestSort={requestSort}
              sortConfig={sortConfig}
            />

            {onHeaderChange(values)}
          </tr>
        </thead>
        <tbody>{showUserList(items)}</tbody>
      </table>
    </div>
  );
};

ShiftList.propTypes = {
  excelRef: PropTypes.any,
  loading: PropTypes.bool,
  values: PropTypes.object.isRequired,
  shiftListData: PropTypes.array,
  dateArrayState: PropTypes.array.isRequired,
  dateDifference: PropTypes.number.isRequired
};

export default ShiftList;
